import {FC} from 'react'
import { getStyledSectionWrapperInset } from '../../styled-components/SectionWrapper.styled'

export interface SectionWrapperProps {
    children: JSX.Element
}

export const SectionWrapper: FC<SectionWrapperProps> = ({children}) => {

    const StyledSectionWrapper = getStyledSectionWrapperInset()

    return(
        <StyledSectionWrapper>
            {children}
        </StyledSectionWrapper>    
    )
}